import React, { useState, useEffect } from 'react';
import { Field } from 'redux-form';
import { connect } from 'react-redux';
import { getCantones, getDistritos, getBarrios } from '../../actions';
import { provincias } from '../../catalogos';
import { renderInput, renderSelect } from '../../util';

const Direccion = (props) => {
  const [cantones, setCantones] = useState([{ value: '0', nombre: 'Selecionar cantón' }]);
  const [distritos, setDistritos] = useState([{ value: '0', nombre: 'Selecionar distrito' }]);
  const [barrios, setBarrios] = useState([{ value: '0', nombre: 'Selecionar barrio' }]);
  const { cantonesState, distritosState, barriosState } = props;
  const { token, Ubicacion } = props;
  const [direcion, setDirecion] = useState(Ubicacion);

  useEffect(() => {
    if (Ubicacion !== null && Ubicacion.Provincia !== null && Ubicacion.Provincia !== '0') {
      props.getCantones(token, Ubicacion.Provincia);
      props.getDistritos(token, Ubicacion.Provincia, Ubicacion.Canton);
      props.getBarrios(token, Ubicacion.Provincia, Ubicacion.Canton, Ubicacion.Distrito);
    }

  }, [Ubicacion])

  useEffect(() => {
    if (cantonesState?.cantones) {

      const catonesItems = [];
      cantonesState.cantones.map(item => {
        catonesItems.push({ value: item.CantonId, display: item.NombreCanto });
      });

      setCantones(catonesItems);
    }
  }, [cantonesState]);

  useEffect(() => {
    if (distritosState?.distritos) {

      const distritosItems = [];
      distritosState.distritos.map(item => {
        distritosItems.push({ value: item.DistritoId, display: item.NombreDistrito });
      });

      setDistritos(distritosItems);
    }
  }, [distritosState]);

  useEffect(() => {
    if (barriosState?.barrios) {

      const barriosItems = [];
      barriosState.barrios.map(item => {
        barriosItems.push({ value: item.BarrioId, display: item.NombreBarrio });
      });

      setBarrios(barriosItems);
    }
  }, [barriosState]);

  const onChangeProvincia = (value) => {
    setDirecion({ ...direcion, Provincia: value });
    props.getCantones(token, value);
    props.getDistritos(token, value, '01');
    props.getBarrios(token, value, '01', '01');
  };

  const onChangeCantones = (value) => {
    setDirecion({ ...direcion, Canton: value });
    props.getDistritos(token, direcion.Provincia, value);
    setBarrios([]);
  }

  const onChangeDistritos = (value) => {
    setDirecion({ ...direcion, Distrito: value });
    props.getBarrios(token, direcion.Provincia, direcion.Canton, value);
  }

  return (
    <>
      <div className="ui segment grid">
        <div className="stackable centered row">
          <div className="five wide column">
            <div>
              <Field
                label="Provincia"
                name="Ubicacion.Provincia"
                component={renderSelect}
                type="select"
                options={provincias}
                value={direcion.Provincia}
                onChange={e => onChangeProvincia(e.target.value)}
                required
              />
            </div>
          </div>
          <div className="five wide column">
            <div>
              <Field
                label="Cantón"
                name="Ubicacion.Canton"
                component={renderSelect}
                type="select"
                options={cantones}
                value={direcion.Canton}
                onChange={e => onChangeCantones(e.target.value)}
              />
            </div>
          </div>
          <div className="six wide column">
            <div>
              <Field
                label="Distrito"
                name="Ubicacion.Distrito"
                component={renderSelect}
                type="select"
                options={distritos}
                value={direcion.Distrito}
                onChange={e => onChangeDistritos(e.target.value)}
              />
            </div>
          </div>
          <div className="five wide column">
            <div>
              <Field
                label="Barrio"
                name="Ubicacion.Barrio"
                component={renderSelect}
                type="select"
                options={barrios}
                value={direcion.Barrio}
                onChange={e => setDirecion({ ...direcion, Barrio: e.target.value })}
              />
            </div>
          </div>
          <div className="eleven wide column">
            <div>
              <Field
                label="Otras señas"
                name="Ubicacion.OtrasSenas"
                component={renderInput}
                type="text"
                placeholder="Otras señas"
                value={direcion.OtrasSenas}
                onChange={e => setDirecion({ ...direcion, OtrasSenas: e.target.value })}
              />
            </div>
          </div>
        </div>

      </div>
    </>
  )
};

const mapStateToProps = (state) => {
  return {
    cantonesState: state.cantonesState,
    distritosState: state.distritosState,
    barriosState: state.barriosState,
  };
}
export default connect(mapStateToProps, { getCantones, getDistritos, getBarrios })(Direccion)